module.exports = __webpack_public_path__ + "static/media/FunExercise – 1.f33bf631.jpg";